module.exports = __webpack_public_path__ + "img/44.d083e458.jpg";